<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
            @click="toggleHeader"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab></settings-tab>
      <div class="row">
        <others-sidebar></others-sidebar>
        <div class="col-xl-9">
          <div class="card">
            <div class="card-header px-0 mx-3">
              <div class="row g-3 align-items-center">
                <div class="col-md-6 col-sm-4">
                  <h6
                    class="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0"
                  >
                    <router-link to="/others-settings/cronjob">
                      <i class="ti ti-arrow-left me-2"></i>Cron Schedule
                    </router-link>
                  </h6>
                </div>
                <div class="col-md-6 col-sm-8">
                  <div
                    class="d-flex justify-content-sm-end align-items-center flex-wrap row-gap-2"
                  >
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#add_cronjobschedule"
                      @click="openAdd"
                    >
                      <i class="ti ti-circle-plus me-2"></i>Add Schedule
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body pb-0">
              <div class="card mb-3">
                <div class="card-header">
                  <div class="row align-items-center g-3">
                    <div class="col-sm-8">
                      <h6>Cron Schedule List</h6>
                    </div>
                    <div class="col-sm-4">
                      <div class="position-relative search-input">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Search"
                          v-model="search"
                        />
                        <div class="search-addon">
                          <span><i class="ti ti-search"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table">
                      <thead class="thead-light">
                        <tr>
                          <th class="no-sort">
                            <div class="form-check form-check-md">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="select-all"
                                :checked="isAllSelected"
                                @change="toggleSelectAll"
                              />
                            </div>
                          </th>
                          <th>Name</th>
                          <th>Interval</th>
                          <th>Enable</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="loading">
                          <td colspan="5" class="text-center py-3">
                            Loading schedules...
                          </td>
                        </tr>
                        <tr v-if="!loading && !filteredRows.length">
                          <td colspan="5" class="text-center py-3">
                            No schedules found.
                          </td>
                        </tr>
                        <tr v-for="item in filteredRows" :key="item.id">
                          <td>
                            <div class="form-check form-check-md">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :value="item.id"
                                v-model="selectedIds"
                              />
                            </div>
                          </td>
                          <td>
                            <h6 class="fw-medium">{{ item.name }}</h6>
                          </td>
                          <td>
                            {{ item.interval_label || item.interval || "-" }}
                          </td>
                          <td>
                            <div
                              class="form-check form-check-md form-switch me-2"
                            >
                              <input
                                class="form-check-input me-2"
                                type="checkbox"
                                role="switch"
                                :checked="item.is_enabled"
                                @change="toggleSchedule(item)"
                              />
                            </div>
                          </td>
                          <td>
                            <div class="action-icon d-inline-flex">
                              <a
                                href="javascript:void(0);"
                                class="me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_cronjobschedule"
                                @click="openEdit(item)"
                              >
                                <i class="ti ti-edit"></i>
                              </a>

                              <a
                                href="javascript:void(0);"
                                data-bs-toggle="modal"
                                data-bs-target="#delete_modal"
                                @click="confirmDelete(item)"
                              >
                                <i class="ti ti-trash"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    class="d-flex justify-content-end align-items-center border-top px-3 py-2"
                    v-if="selectedIds.length"
                  >
                    <button
                      class="btn btn-outline-danger btn-sm"
                      type="button"
                      @click="handleBulkDelete"
                    >
                      <i class="ti ti-trash me-1"></i> Delete Selected
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <cronjob-schedule-modal @confirm-delete="handleBulkDelete" />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useCronScheduleStore } from "@/stores/settings/cron-schedule.store";

const title = "Settings";
const text = "Administration";
const text1 = "Settings";

const cronScheduleStore = useCronScheduleStore();

function openAdd() {
  cronScheduleStore.clearCurrent();
}

function openEdit(item) {
  cronScheduleStore.setCurrent(item);
}

const loading = computed(() => cronScheduleStore.loading);
const rows = computed(() => cronScheduleStore.rows);

const search = ref("");
const selectedIds = ref([]);

const filteredRows = computed(() => {
  if (!search.value) return rows.value;
  const term = search.value.toLowerCase();
  return rows.value.filter(
    (r) =>
      (r.name || "").toLowerCase().includes(term) ||
      (r.interval_label || r.interval || "").toLowerCase().includes(term)
  );
});

const isAllSelected = computed(() => {
  return (
    filteredRows.value.length > 0 &&
    selectedIds.value.length === filteredRows.value.length
  );
});

function toggleSelectAll(e) {
  if (e.target.checked) {
    selectedIds.value = filteredRows.value.map((r) => r.id);
  } else {
    selectedIds.value = [];
  }
}

function toggleHeader() {
  document.getElementById("collapse-header").classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function toggleSchedule(item) {
  if (!item?.id) return;
  await cronScheduleStore.toggle(item.id);
}

function confirmDelete(item) {
  // generic confirmation modal handles delete; here we just remember selection if needed
  selectedIds.value = [item.id];
}

async function handleBulkDelete() {
  if (!selectedIds.value.length) return;
  await cronScheduleStore.bulkDelete(selectedIds.value);
  selectedIds.value = [];
}

onMounted(() => {
  cronScheduleStore.fetchList();
});
</script>


